//import './polyfills';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { GlobalConstants } from './core/GlobalConstants';


console.info("Application startup: load translation file...");

fetch("/assets/translation.json")
	.then(res=>res.text()).then(text => {
		console.info("Application startup: translation file loaded, starting application...");
		try {
			window[GlobalConstants.WINDOW_PROPERTY_TranslationData] = JSON.parse(text);
		} catch (error) {
			console.error("Application startup: translation file could not be parsed as JSON object: " + error);
			try {
				console.error("Application startup: translation data = \n" + text);
			} catch (error) {
				console.error("Application startup: error while trying to show translation file content: " + error);
			}
			throw new Error("Application startup: translation file could not be parsed as JSON object: " + error);
		}
		platformBrowserDynamic().bootstrapModule(AppModule);
	})
	.catch( (reason: any) => {
		console.error("Application startup: translation file NOT loaded, reason = " + reason);
		throw new Error("Application startup: translation file NOT loaded, reason = " + reason);
	});



// WEBPACK FOOTER //
// ./src/app/main.ts